const title = {
  type: 'Label',
  name: '7',
  fontSize: '20px',
  lineHeight: '25px',
  fontSizeMedium: '24px',
  lineHeightMedium: '30px',
  fontWeight: '850',
  textTransform: 'uppercase',
  paddingBottomMedium: '32px'
}

const blockTitle = {
  type: 'Heading',
  name: 'B3',
  fontSize: '20px'
}

const blockText = {
  type: 'Paragraph',
  name: '3'
}

const loyaltyRewardsCarousel = {
  title,
  blockTitle,
  blockText
}

export default loyaltyRewardsCarousel
